/* import __COLOCATED_TEMPLATE__ from './line-chart.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();